<div class="container navtop">
    <form [formGroup]="formGroup" >

        <div class="row justify-content-center">
            <mat-card class="col-11 col-lg-7">
                <mat-card-content>

                    <mat-progress-bar class="row " *ngIf="loading" mode="indeterminate"></mat-progress-bar>
                    <h2 class="row justify-content-center"><b>{{ 'SUBSCRIBE.TITLE1' | translate }}</b></h2>




                    <!-- nom prenom -->
                    <div class="row justify-content-center">
                        <mat-form-field class="col-5">
                            <input matInput placeholder="{{ 'SUBSCRIBE.LASTNAME' | translate }} :" formControlName="lastname" required>
                            <mat-error
                                *ngIf="!formGroup.controls['lastname'].valid || formGroup.controls['lastname'].touched">
                                {{ getErrorLastname() }}
                            </mat-error>
                        </mat-form-field>
                        <mat-form-field class="col-5">
                            <input matInput placeholder="{{ 'SUBSCRIBE.FIRSTNAME' | translate }} :" formControlName="firstname" required>
                            <mat-error
                                *ngIf="!formGroup.controls['firstname'].valid || formGroup.controls['firstname'].touched">
                                {{ getErrorFirstname() }}
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <!-- nom d'utilisateur -->
                    <div class="row justify-content-center">
                        <mat-form-field class="col-10">
                            <input matInput placeholder="{{ 'SUBSCRIBE.NAME' | translate }} :" formControlName="name" required>
                            <mat-error
                                *ngIf="!formGroup.controls['name'].valid || formGroup.controls['name'].touched">
                                {{ getErrorUsername() }}
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <!-- Date de naissance -->
                    <div class="row justify-content-center">
                        <mat-form-field (click)="picker.open()" class="col-10">
                            <mat-label>{{ 'SUBSCRIBE.BIRTHDAY' | translate }} :</mat-label>
                            <input matInput [matDatepicker]="picker" disabled="true" [max]="maxDate"
                                [(ngModel)]="birthdate" formControlName="birthdate" required>
                            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                            <mat-datepicker touchUi="true" disabled="false" #picker></mat-datepicker>
                            <mat-error
                                *ngIf="!formGroup.controls['birthdate'].valid || formGroup.controls['birthdate'].touched">
                                {{ getErrorDate() }}
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <!-- Adresse email -->
                    <div class="row justify-content-center">
                        <mat-form-field class="col-10">
                            <input matInput placeholder="{{ 'SUBSCRIBE.EMAIL' | translate }} :" formControlName="email" required>
                            <mat-error
                                *ngIf="!formGroup.controls['email'].valid || formGroup.controls['email'].touched">
                                {{ getErrorEmail() }}
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <!-- Numéro de téléphone -->
                    <div class="row justify-content-center">
                        <mat-form-field class="col-10" >
                            <ngx-mat-intl-tel-input formControlName="phonenumber"
                            [preferredCountries]="['fr', 'gp']"
                            [enablePlaceholder]="true"
                            [enableSearch]="true" name="phonenumber" #phonenumber  >
                          </ngx-mat-intl-tel-input>
                            <mat-error
                                *ngIf="!formGroup.controls['phonenumber'].valid || formGroup.controls['phonenumber'].touched">
                                {{ getErrorPhonenumber() }}
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <!-- Société -->
                    <div *ngIf="covoiturage === false" class="row justify-content-center">
                        <mat-form-field class="col-10">
                            <input matInput placeholder="{{ 'SUBSCRIBE.FACTORY' | translate }}" formControlName="company" >
                        </mat-form-field>
                    </div>

                    <!-- Code d'invitation -->
                    <div *ngIf="covoiturage === false" class="row justify-content-center">
                        <mat-form-field class="col-10">
                            <input matInput placeholder="{{ 'SUBSCRIBE.INVITATION' | translate }}" formControlName="invitation">
                        </mat-form-field>
                    </div>

                </mat-card-content>
            </mat-card>



        </div>




        <!-- Permis de Conduire -->
        <div *ngIf="covoiturage === false" class="row justify-content-center mt-5">
            <mat-card class="col-11 col-lg-7">
                <mat-card-content>

                    <mat-progress-bar class="row " *ngIf="loading" mode="indeterminate"></mat-progress-bar>
                    <h2 class="row justify-content-center"><b>{{ 'SUBSCRIBE.TITLE2' | translate }}</b></h2>



                    <div class="row justify-content-center">
                        <mat-form-field class="col-10">
                            <mat-label *ngIf="nameFilePermis; else newFile">{{nameFilePermis}}</mat-label>
                            <ng-template #newFile>
                                <mat-label>{{ 'SUBSCRIBE.RECTO' | translate }} *</mat-label>
                            </ng-template>
                            <input matInput disabled>
                            <button mat-icon-button matSuffix (click)="fileInput.click()">
                                <mat-icon>attach_file</mat-icon>
                            </button>
                            <input name="license" hidden (change)="fileChangePermis($event)" #fileInput
                                type="file" id="file" accept="image/*,application/pdf">
                        </mat-form-field>

                    </div>




                    <div class="row justify-content-center">
                        <mat-form-field class="col-10">
                            <mat-label *ngIf="nameFilePermisBack; else newFileBack">{{nameFilePermisBack}}</mat-label>
                            <ng-template #newFileBack>
                                <mat-label>{{ 'SUBSCRIBE.VERSO' | translate }}</mat-label>
                            </ng-template>
                            <input matInput disabled>
                            <button mat-icon-button matSuffix (click)="fileInputBack.click()">
                                <mat-icon>attach_file</mat-icon>
                            </button>
                            <input name="license_back" hidden (change)="fileChangePermisBack($event)" #fileInputBack
                                type="file" id="file" accept="image/*,application/pdf">
                        </mat-form-field>
                    </div>




                </mat-card-content>
            </mat-card>



        </div>


         <!-- piece d identité  -->
         <div *ngIf="covoiturage === true" class="row justify-content-center mt-5">
            <mat-card class="col-11 col-lg-7">
                <mat-card-content>

                    <mat-progress-bar class="row " *ngIf="loading" mode="indeterminate"></mat-progress-bar>
                    <h2 class="row justify-content-center"><b>Piece d'identité</b></h2>



                    <div class="row justify-content-center">
                        <mat-form-field class="col-10">
                            <mat-label *ngIf="nameFileCard; else newCard">{{nameFileCard}}</mat-label>
                            <ng-template #newCard>
                                <mat-label>{{ 'SUBSCRIBE.RECTO' | translate }} *</mat-label>
                            </ng-template>
                            <input matInput disabled>
                            <button mat-icon-button matSuffix (click)="cardInput.click()">
                                <mat-icon>attach_file</mat-icon>
                            </button>
                            <input name="license" hidden (change)="fileChangeCard($event)" #cardInput
                                type="file" id="file" accept="image/*,application/pdf">
                        </mat-form-field>

                    </div>




                    <div class="row justify-content-center">
                        <mat-form-field class="col-10">
                            <mat-label *ngIf="nameFileCardBack; else newCardBack">{{nameFileCardBack}}</mat-label>
                            <ng-template #newCardBack>
                                <mat-label>{{ 'SUBSCRIBE.VERSO' | translate }}</mat-label>
                            </ng-template>
                            <input matInput disabled>
                            <button mat-icon-button matSuffix (click)="cardInputBack.click()">
                                <mat-icon>attach_file</mat-icon>
                            </button>
                            <input name="license_back" hidden (change)="fileChangeCardBack($event)" #cardInputBack
                                type="file" id="file" accept="image/*,application/pdf">
                        </mat-form-field>
                    </div>




                </mat-card-content>
            </mat-card>



        </div>



    
            <div class="row  justify-content-center mt-5">

              <label class="col-10 col-md-7 blocv">
                <mat-checkbox  class="mr-1"
                formControlName="cgu" ></mat-checkbox>
                <a class="col-10" [ngStyle]=" submitted && f.cgu.errors ? {'color': 'red'}  : {'color': 'rgba(124,123,123,.87)'}" target="target"
                  routerLink="/cgu">{{'SEARCH.STATIONCONFIRMECGU' | translate }}</a>
              </label>

            </div>

       
       

        <div class="row justify-content-center mt-5">
            <button class="col-6 col-md-3 color-theme" mat-raised-button color="primary"
            (click)="signUp()" type="submit" >{{ 'SUBSCRIBE.BOUTON' | translate }}</button>
        </div>

    </form>
</div>